import * as React from "react";
import { InputWithAlert } from "../ui/input-with-alert";
import { formatDateString } from "@/styles";
import { format } from "date-fns";
import {
  NIEPODJECIE,
  PODJECIE,
  ZAKONCZENIE_PRACY,
} from "@/constants";
import { useTranslation } from "react-i18next";
import OswiadczenieAdditionalDocument from "../popups/documents/oswiadczenie-additiona-documents.popup";

export const DocumentOswiadczenie = (props) => {
  const { document, clientId } = props;
  const { entityType, createdAt, status, validFrom, validTo, uniqueId } =
    document;

  const {
    podjecie,
    niepodjecie,
    tytul,
    minimum_amount,
    oswiadczenie_type,
    zakonczenie,
  } = document.metadata;
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="pt-6">
        <InputWithAlert
          label={t("document_type")}
          disabled={true}
          type="text"
          value={entityType}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("created_at")}
          disabled={true}
          type="text"
          value={formatDateString(createdAt)}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("status")}
          disabled={true}
          type="text"
          value={status}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("unique_id")}
          disabled={true}
          type="text"
          value={uniqueId ? uniqueId : t("not_specified")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("valid_from")}
          disabled={true}
          type="text"
          value={format(new Date(validFrom), "dd.MM.yyyy")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("valid_to")}
          disabled={true}
          type="text"
          value={format(new Date(validTo), "dd.MM.yyyy")}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>

      <div className="pt-6">
        <InputWithAlert
          label={t("oswiadczenie_type")}
          disabled={true}
          type="text"
          value={oswiadczenie_type?.value ? oswiadczenie_type.value : ''}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("tytul")}
          disabled={true}
          type="text"
          value={tytul}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("minimum_amount")}
          disabled={true}
          type="text"
          value={minimum_amount}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("niepodjecie")}
          disabled={true}
          type="text"
          value={
            niepodjecie ? format(new Date(niepodjecie), "dd.MM.yyyy") : "-"
          }
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t("podjecie")}
          disabled={true}
          type="text"
          value={podjecie ? format(new Date(podjecie), "dd.MM.yyyy") : "-"}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      <div className="pt-6 pb-6">
        <InputWithAlert
          label={t("zakonczenie")}
          disabled={true}
          type="text"
          value={
            zakonczenie ? format(new Date(zakonczenie), "dd.MM.yyyy") : "-"
          }
          inputClassName={"h-[40px] w-full  mt-2"}
        />
      </div>
      {!podjecie && (
        <OswiadczenieAdditionalDocument
          clientId={clientId}
          oswiadczenieId={document.id}
          typeOfDocument={PODJECIE}
          from={new Date(validFrom)}
          to={new Date(validTo)}
        />
      )}
      {!niepodjecie && !podjecie && (
        <OswiadczenieAdditionalDocument
          clientId={clientId}
          oswiadczenieId={document.id}
          typeOfDocument={NIEPODJECIE}
          from={new Date(validFrom)}
          to={new Date(validTo)}
        />
      )}
      {podjecie && !zakonczenie && (
        <OswiadczenieAdditionalDocument
          clientId={clientId}
          oswiadczenieId={document.id}
          typeOfDocument={ZAKONCZENIE_PRACY}
          from={new Date(validFrom)}
          to={new Date(validTo)}
          />
      )}
    </div>
  );
};
